module.exports = __webpack_public_path__ + "static/BannerCarers-85c51ac9e99a4facb9ba314514007656.png";